import { Box, Text, HStack, useColorModeValue, Link, Icon } from '@chakra-ui/react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { Link as RouterLink } from 'react-router-dom';
import { PathSegment } from '../contexts/location/LocationContext';
import { FaHome } from 'react-icons/fa';

interface LocationBarProps {
  path: PathSegment[];
}

const LocationBar = ({ path }: LocationBarProps) => {
  
  return (
    <Box width="100%" bg={useColorModeValue('white', 'gray.800')} color={useColorModeValue('black','white')} py={2} px={4}>
      <HStack spacing={2}>
      <Link as={RouterLink} to="/">
          <Icon as={FaHome} />
        </Link>
        <ChevronRightIcon />
        {path.map((segment, index) => (
          <HStack key={index} spacing={2}>
            {index > 0 && <ChevronRightIcon />}
            <Link as={RouterLink} to={segment.url}>
              <Text>{segment.text}</Text>
            </Link>
          </HStack>
        ))}
      </HStack>
    </Box>
  );
};

export default LocationBar;
